"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.reflect.construct.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.generateCommonPassedProps = void 0;

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.reverse.js");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _fieldWrapper = _interopRequireDefault(require("../fieldWrapper"));

var _lodash = _interopRequireDefault(require("lodash"));

var _validations = require("../../validations");

var _formElements = require("@evidation/form-elements");

var _Field = _interopRequireDefault(require("../../utils/Field"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LanguageContext = require("../../contexts/LanguageContext");

var _reactI18next = require("react-i18next");

var _excluded = ["collapseable", "i", "label", "smallLabel", "key", "description", "question_description", "title", "labelStyle", "styles", "config", "validate", "fieldSpacing", "normalize", "format", "parse"],
    _excluded2 = ["min", "max", "default_select_value", "sort_ascending"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var generateCommonPassedProps = function generateCommonPassedProps(_ref) {
  var collapseable = _ref.collapseable,
      _ref$i = _ref.i,
      i = _ref$i === void 0 ? 0 : _ref$i,
      label = _ref.label,
      smallLabel = _ref.smallLabel,
      key = _ref.key,
      description = _ref.description,
      question_description = _ref.question_description,
      title = _ref.title,
      labelStyle = _ref.labelStyle,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$validate = _ref.validate,
      validate = _ref$validate === void 0 ? [] : _ref$validate,
      fieldSpacing = _ref.fieldSpacing,
      normalize = _ref.normalize,
      format = _ref.format,
      parse = _ref.parse,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var listOfValidations = props.required ? [].concat((0, _toConsumableArray2["default"])(validate), [_validations.required]) : (0, _toConsumableArray2["default"])(validate);
  var wrapperContent = {
    collapseable: collapseable,
    smallLabel: smallLabel,
    label: label,
    question_description: question_description,
    key: i,
    description: description,
    title: title,
    style: _objectSpread(_objectSpread({
      marginBottom: fieldSpacing
    }, styles), config)
  };
  var fieldName = key || props.name;
  var commonPassedProps = {
    name: fieldName
  };

  if (_lodash["default"].isFunction(normalize) && !_lodash["default"].isUndefined(normalize)) {
    commonPassedProps["normalize"] = normalize;
  }

  if (_lodash["default"].isFunction(format) && !_lodash["default"].isUndefined(format)) {
    commonPassedProps["format"] = format;
  }

  if (_lodash["default"].isFunction(parse) && !_lodash["default"].isUndefined(parse)) {
    commonPassedProps["parse"] = parse;
  }

  return {
    listOfValidations: listOfValidations,
    wrapperContent: wrapperContent,
    fieldName: fieldName,
    commonPassedProps: commonPassedProps
  };
};

exports.generateCommonPassedProps = generateCommonPassedProps;

var generateListOfNumbers = function generateListOfNumbers(lowEnd, highEnd) {
  var min = parseInt(lowEnd);
  var max = parseInt(highEnd);
  var list = [];

  for (var i = min; i <= max; i++) {
    list.push({
      value: i,
      label: i
    });
  }

  return list;
};

var NumberRangeInput = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(NumberRangeInput, _React$PureComponent);

  var _super = _createSuper(NumberRangeInput);

  function NumberRangeInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, NumberRangeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectNotDefaultValue", function (v) {
      var t = _this.props.t;

      if (v && _lodash["default"].isEqual(v, _this.props.default_select_value) || _lodash["default"].isUndefined(v)) {
        return t('validations.required');
      }

      return undefined;
    });
    return _this;
  }

  (0, _createClass2["default"])(NumberRangeInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          default_select_value = _this$props.default_select_value,
          sort_ascending = _this$props.sort_ascending,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded2);
      var options = generateListOfNumbers(min, max);

      var _generateCommonPassed = generateCommonPassedProps(props),
          listOfValidations = _generateCommonPassed.listOfValidations,
          wrapperContent = _generateCommonPassed.wrapperContent,
          commonPassedProps = _generateCommonPassed.commonPassedProps;

      if (props.required) {
        listOfValidations = [].concat((0, _toConsumableArray2["default"])(listOfValidations), [this.selectNotDefaultValue]);
      }

      if (_lodash["default"].isString(sort_ascending)) {
        sort_ascending = _lodash["default"].isEqual(sort_ascending, "true") ? true : false;
      }

      if (!sort_ascending) {
        options.reverse();
      }

      return /*#__PURE__*/_react["default"].createElement(_fieldWrapper["default"], wrapperContent, /*#__PURE__*/_react["default"].createElement(_Field["default"], (0, _extends2["default"])({
        required: props.required,
        component: function component(_ref2) {
          var input = _ref2.input;
          return /*#__PURE__*/_react["default"].createElement(_formElements.SelectInput, (0, _extends2["default"])({}, props, {
            initialValue: default_select_value,
            options: options,
            onChange: function onChange(d) {
              input.onChange(d);
              input.onBlur(d);
            },
            value: input.value
          }));
        },
        validate: listOfValidations,
        options: generateListOfNumbers(min, max)
      }, commonPassedProps, {
        config: _objectSpread(_objectSpread({}, props), props.config)
      })));
    }
  }]);
  return NumberRangeInput;
}(_react["default"].PureComponent);

NumberRangeInput.propTypes = {
  sort_ascending: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].oneOf(["true", "false"])]).isRequired,
  default_select_value: _propTypes["default"].string.isRequired,
  min: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  max: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired
};
NumberRangeInput.defaultProps = {
  sort_ascending: false,
  default_select_value: "---Choose One---",
  min: 0,
  max: 100
};

var _default = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(NumberRangeInput);

exports["default"] = _default;